export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 return emailRegex.test(email);
}
export const validatePassword = (password) => {
 return password.length >= 8;
}


export const validateAvatarUrl = (avatar) => {
    const urlPattern = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .,?=&%#-]*)*\/?$/i;
    return urlPattern.test(avatar);
}

export const validateUserName = (name) => {
    return typeof name === "string" && name.trim().length >= 2 && name.trim().length <= 30;
}
